import { render, staticRenderFns } from "./educ-content-page.vue?vue&type=template&id=2ae1415c&scoped=true"
import script from "./educ-content-page.vue?vue&type=script&lang=js"
export * from "./educ-content-page.vue?vue&type=script&lang=js"
import style0 from "./educ-content-page.vue?vue&type=style&index=0&id=2ae1415c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1415c",
  null
  
)

export default component.exports